import React, { useState } from 'react';
import { FaUtensils, FaEnvelope, FaLock } from 'react-icons/fa';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Local Admin Check
    if (email === "admin@inflammascan.app" && password === "inflammaAdmin321@#@") {
      localStorage.setItem("isLocalAdmin", "true");
      navigate("/");
      setLoading(false);
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.removeItem("isLocalAdmin"); // Ensure local flag is cleared if using real auth
      navigate("/");
    } catch (err) {
      console.error("Login error:", err);
      setError("Failed to sign in. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-main-gradient bg-cover bg-no-repeat px-4 py-8">
      <div className=" sm:bg-white md:bg-white lg:bg-white xl:bg-white rounded-xl sm:shadow-lg p-8 w-full max-w-md flex flex-col items-center">
        <div className="mb-4 flex flex-col items-center">
          <div className="bg-[#fff0e0] rounded-full p-4 mb-2">
            <FaUtensils className="text-4xl text-[#d90429]" />
          </div>
          <h2 className="text-2xl font-semibold mb-2 text-gray-800">Inflamma Scan</h2>
        </div>
        <form className="w-full" onSubmit={handleLogin}>
          <div className="mb-4 relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#d90429]">
              <FaEnvelope />
            </span>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full pl-10 pr-3 py-2 rounded-md bg-[#fff7e6] border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#d90429] text-gray-800 placeholder-gray-400"
            />
          </div>
          <div className="mb-2 relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#d90429]">
              <FaLock />
            </span>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full pl-10 pr-10 py-2 rounded-md bg-[#fff7e6] border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#d90429] text-gray-800 placeholder-gray-400"
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#d90429] focus:outline-none"
              onClick={() => setShowPassword((prev) => !prev)}
              tabIndex={-1}
            >
              {showPassword ? (
                <FaEyeSlash className="h-5 w-5" />
              ) : (
                <FaEye className="h-5 w-5" />
              )}
            </button>
          </div>
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#d90429] mt-8 text-white py-2 rounded-md font-semibold text-lg hover:bg-[#b80322] transition mb-2 shadow disabled:opacity-50"
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
